<script>
import Layout from '@layouts/main'

export default {
  page() {
    return {
      title: this.user.name,
      meta: [
        {
          name: 'description',
          content: `The user profile for ${this.user.name}.`,
        },
      ],
    }
  },
  components: { Layout },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <layout>
    <h1>
      <BaseIcon name="user"/>
      {{ user.name }}
      Profile
    </h1>
    <pre>{{ user }}</pre>
  </layout>
</template>
